import { DeviceDetectorService } from 'ngx-device-detector';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogData } from './dialog-data.class';
import { ModalComponent } from './modal/modal.component';
import { NotesModalComponent } from './notes-modal/notes-modal.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(
    private dialog: MatDialog,
    private deviceService: DeviceDetectorService
  ) { }

  /**
   * Wrapper for the material dialog. Used to set the default config.
   * @param dialogParams Config options for the dialog.
   */
  openDialog(dialogParams: DialogData) {
    return this.dialog.open(ModalComponent, {
      width: this.deviceService.isMobile() ? '95vw' : '500px',
      data: dialogParams,
      disableClose: dialogParams.disableClose,
      enterAnimationDuration: '0ms',
      exitAnimationDuration: '0ms',
    });
  }

  openNotesDialog(dialogParams: DialogData) {
    return this.dialog.open(NotesModalComponent, {
      width: '500px',
      data: dialogParams,
      disableClose: dialogParams.disableClose,
      enterAnimationDuration: '0ms',
      exitAnimationDuration: '0ms',
    });
  }
}
